<template>
  <li :class="[optionClass, { 'active': isActive  }, 'bloption']"
    :style="optionsStyle"
    :key="option.title">
    <a class="opt" :ref="`option-${option.value}`">
      {{ option.label }}
      <i class="cicloremove ms-Icon ms-Icon--Cancel"
          aria-hidden="true"></i>
    </a>
  </li>
</template>

<script>
  export default {
    props:['option','isActive','optionsStyle',"optionClass"],    
  }
</script>

<style scoped>
li.bloption * {
  box-sizing: border-box !important;
}


li.bloption:hover,
li.bloption.active {
  background-color: #ccc;
}

li.bloption{
  padding-top: 7.5px;
  padding-bottom: 7.5px;
  position: relative;
  padding-left: 50px;
}

li.bloption a {
  color: black;
  line-height: 32px;
  padding-left: 0;
  width: 100%;
  display: block;
  color: rgb(49, 49, 49);
  font-family: Montserrat,serif;
  font-size: 14.5px;
}

li.bloption a.two-or-more-lines{
  line-height: 1.9;
}

.cicloremove {
  display: none;
  float: left;
  margin-right: 0;
  z-index: 0;
  font-size: 14px;
  right: 10px;
  bottom: 0;
  position: absolute;
  top: 50%;
  transform: translate(-0%, -100%);
}

a.opt {
  box-sizing: border-box !important;
}

.active a.opt {
  position: relative;
}

.active .cicloremove {
  display: block;
  z-index: 0;
}

@media (max-width: 1200px) {
  li.bloption {
    padding-right: 20px;
    padding-left: 20px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
}

@media (max-width: 767px) {
  li.bloption {
    padding-left: 50px;
    padding-top: 15px;
  }

  li.bloption a {
    font-size: 12px;
    line-height: 18px;

  }

  .cicloremove{
    right: -7px;
    font-size: 17px;
  }
}
</style>